export const ACCESS_TOKEN = "accessToken"

export const RESET_REDUX_STORE_EVENT = "reset-redux-store"
